<template>
<div class="dropdown">
    <button
        type="button"
        class="btn btn-sm btn-light dropdown-toggle"
        data-toggle="dropdown"
        data-display="static"
        aria-haspopup="true"
        aria-expanded="false"
    >
        Actions
    </button>
    <div class="dropdown-menu dropdown-menu-right" :class="{ 'position-relative': options.length > 4 }">
        <button
            v-for="(option, i) in options"
            :key="i"
			:disabled="optionRules(option.key)"
            type="button"
            class="dropdown-item"
            @click="onAction(option.key)"
        >
            {{ option.label }}
        </button>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'ActionColumn',
	props: {
		data: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			actionsOptins: {
				dropshipper: [
					{
						label: 'Mark as Received',
						key: 'mark_as_received',
					},
				],
				supplier: [
					{
						label: 'Mark as delivery',
						key: 'mark_as_delivery',
					},
					{
						label: 'Input Receipt Number',
						key: 'input_receipt_number',
					},
				],
			},
			adminActions: [
				{
					label: 'Process Orders',
					key: 'process_orders',
				},
				{
					label: 'Input Receipt Number',
					key: 'input_receipt_number',
				},
				{
					label: 'Edit Order',
					key: 'edit_order',
				},
				{
					label: 'Update Status',
					key: 'update_status',
				},
			],
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOwner: 'isOwner',
			isAdmin: 'isAdmin',
			isUserCan: 'isUserCan',
		}),
		options() {
			let options = this.adminActions;
			if (this?.user?.owner_type) {
				options = this.actionsOptins?.[this.user?.owner_type] ?? [];
			} else if (!this?.user?.owner_type && !this.isAdmin) {
				options = this.actionsOptins?.supplier ?? [];
			}

			return options;
		},
	},
	methods: {
		onAction(key) {
			this.$emit('on-action', key, this.data);
		},
		optionRules(key) {
			let disabled = false;
			// Process Order Rules
			const index = this.options.findIndex(curr => curr?.key === key);
			if (index !== -1 && (key === 'process_orders' || key === 'edit_order')) {
				if (this.data.status !== 'pending') {
					disabled = true;
				}
			}

			if (index !== -1 && key === 'edit_order') {
				if (this.data.order_type !== 'bulky') {
					disabled = true;
				}
			}

			if (key === 'input_receipt_number' && (!this.isTeamMemberHasAccess('wholesale_input_receipt_number') || this.data.order_type === 'outsource')) {
				disabled = true;
			}

			if (key === 'mark_as_received' && this.data.status !== 'delivery') {
				disabled = true;
			}

			if (key === 'mark_as_delivery' && (!this.isTeamMemberHasAccess('wholesale_mark_as_delivery') || this.data.order_type === 'bulky' || (this.data.order_type === 'outsource' && this.data.status !== 'processing'))) {
				disabled = true;
			}

			return disabled;
		},
		isTeamMemberHasAccess(feature) {
			if ((!this.isOwner && !this.isAdmin) && feature) {
				return this.isUserCan(feature);
			}

			return true;
		},
	},
};
</script>

<style lang="scss" scoped>
// .dropdown-menu {
// 	position: relative !important;
// }
</style>
